import React from 'react';
import { canAccessClubManager, canChangeGlobalSettings, hasPermission } from '../utils/permissions';
import './AdminSidebar.css';

function AdminSidebar({
  activeSection,
  setActiveSection,
  isOpen,
  toggleSidebar,
  permissions = [],
  userRole = '',
}) {
  const canAddUser = hasPermission(permissions, userRole, 'add_user');
  const canManageLobbies = hasPermission(permissions, userRole, 'manage_lobbies');
  const canManageClubs = canAccessClubManager(permissions, userRole);
  const canApproveAvatars = hasPermission(permissions, userRole, 'approve_avatars');
  const canGlobalSettings = canChangeGlobalSettings(permissions, userRole);

  return (
    <div className={`admin-sidebar ${isOpen ? 'open' : 'closed'}`}>
      <ul>
        <li
          className={activeSection === 'userManagement' ? 'active' : ''}
          onClick={() => setActiveSection('userManagement')}
        >
          User Management
        </li>
        {canAddUser && (
          <li
            className={activeSection === 'addUser' ? 'active' : ''}
            onClick={() => setActiveSection('addUser')}
          >
            Add New User
          </li>
        )}
        <li
          className={activeSection === 'roleManagement' ? 'active' : ''}
          onClick={() => setActiveSection('roleManagement')}
        >
          Role Management
        </li>
        {canManageLobbies && (
          <li
            className={activeSection === 'lobbyEditor' ? 'active' : ''}
            onClick={() => setActiveSection('lobbyEditor')}
          >
            Lobby Editor
          </li>
        )}
        {canManageClubs && (
          <li
            className={activeSection === 'clubManager' ? 'active' : ''}
            onClick={() => setActiveSection('clubManager')}
          >
            Club Manager
          </li>
        )}
        {canApproveAvatars && (
          <li
            className={activeSection === 'avatarModeration' ? 'active' : ''}
            onClick={() => setActiveSection('avatarModeration')}
          >
            Avatar approvals
          </li>
        )}
        {canGlobalSettings && (
          <li
            className={activeSection === 'siteSettings' ? 'active' : ''}
            onClick={() => setActiveSection('siteSettings')}
          >
            Site settings
          </li>
        )}
        <li onClick={toggleSidebar}>Close Sidebar</li>
      </ul>
    </div>
  );
}

export default AdminSidebar;